import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { Globe, Whatsapp } from "../ui/AllImages";
import { LazyImage } from "../ui/Elements";


const LangChangeButton = ({ ...props }) => {
  const { i18n } = useTranslation();
  const WhatsApp = () => {
    const phoneNumber = '+966555625502';
    const message = 'Hello, this is Hisas';
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, '_blank');
  };
  const [isEnglishSelected, setIsEnglishSelected] = useState(
    Cookies.get("lang") === "en" ? true : false
  );

  const changeLanguageAndDirection = (lng, dir) => {
    i18n.changeLanguage(lng);
    document.documentElement.dir = dir;
    document.body.classList.toggle("rtl", dir === "rtl");
    document.body.classList.toggle("ltr", dir === "ltr");
    Cookies.set("lang", lng, { expires: 60, path: "/" });
    Cookies.set("dir", dir, { expires: 60, path: "/" });
  };

  const handleLanguageChange = () => {
    const newLang = isEnglishSelected ? "ar" : "en";
    const newDir = isEnglishSelected ? "rtl" : "ltr";
    changeLanguageAndDirection(newLang, newDir);
    setIsEnglishSelected(!isEnglishSelected);
  };

  useEffect(() => {
    const savedLang = Cookies.get("lang") || "ar";
    const savedDir = Cookies.get("dir") || "rtl";

    changeLanguageAndDirection(savedLang, savedDir);
  }, []);

  return (
    <>
      <ButtonBox onClick={handleLanguageChange} {...props}>
        <span className="change-Btn">
          <Globe className="icon" alt={isEnglishSelected ? "Arabic" : "USA"} />
          <span className="lang-text">{isEnglishSelected ? "العربية" : "English"}</span>

        </span>
        <span className="whatsapp" onClick={WhatsApp}>
        <LazyImage src={Whatsapp} />
      </span>
      </ButtonBox>
      
    </>
  );
};

const ButtonBox = styled.div.withConfig({
  shouldForwardProp: (prop) => !["bg", "border", "color", "iconColor"].includes(prop), // Prevent bg and border from being forwarded
})`
  padding: 0;
  cursor: pointer;
  z-index: 1;

  .change-Btn {
    background: ${({ bg }) => (bg ? bg : "var(--themeColor)")};
    border: ${({ border }) => (border ? border : "1px solid var(--themeColor)")};
    border-radius: 22px;
    color: ${({ color }) => (color ? color : "var(--bg2)")};
    display: flex;
    align-items: center;
    font-size: 16px;
    height: 42px;
    padding: 0px 16px;
    position: relative;
    /* text-transform: uppercase; */

    svg {
      width: 22px;
      height: auto;
      margin: 0 6px;
      [stroke] {
        stroke: ${({ iconColor }) => (iconColor ? iconColor : "var(--bg2)")};
      }
      [fill] {
        fill: ${({ iconColor }) => (iconColor ? iconColor : "var(--bg2)")};
      }
    }

    span {
      padding-bottom: 4px;
      font-family: var(--jannaRegular);
	  body.rtl &{
		font-family: var(--medium);
		padding-bottom: 1px;
		font-size: 16px;
	  }
    }
  }
  .icon {
    cursor: pointer;
    z-index: 1;
  }
.whatsapp {
    position: fixed;
    bottom: 0;
    right: 8px;
    z-index: 1;
  }
  body.rtl &{
    .whatsapp {
      right: unset;
      left: 8px;
    }
  }
  @media (max-width: 500px) {
    .lang-text {
      display: none
    } 
  }
  @media (max-width: 470px) {
    .change-Btn {
      padding: 0 10px!important;
    }
  }
`;

export default LangChangeButton;
